export enum LocaleE {
  en = 'en',
  es = 'es',
  pt = 'pt',
  fr = 'fr',
}
